<div class="layout-wrapper">
    <app-header></app-header>
    <div class="router">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>
